let initalState={
    user_id:"",
    email:"",
    username:""
}

export const AuthReducer =(state=initalState,action)=>{
    switch(action.type){
        case "SET_UID":
            return{
                ...state,
                user_id:action.payload
            }
        case "SET_EMAİL":
            return{
                ...state,
                email:action.payload
            }
        case "CLEAR_EMAİL":
            return{
                ...state,
                email:""
            }
        case "CLEAR_UID":
            return{
                ...state,
                user_id:""
            }
        case "SET_USERNAME":
            return{
                ...state,
                username:action.payload
            }        
        default:
            return state
    }
}